module.exports = __webpack_public_path__ + "img/cover21.3c3a5f51.png";